export default {
  common: {
    pageprev: "上一页",
    pagenext: "下一页",
    home: "网站首页",
    services: "营销服务",
    advantage: "优势",
    news: "新闻资讯",
    about: "关于我们",
    contact: "联系方式",
    loading: "加载中...",
    noData: "暂无数据",
    language: "语言",
    chinese: "中文",
    english: "English",
    nopic: "暂无图片",
    fenxiang: "分享到 :",
    kefuQrcode: "客服二维码",
    websiteQrcode: "网站二维码",
    kefuHotline: "客服热线",
    kefuEmail: "客服邮箱",
    companyAddress: "公司地址",
    backTop: "顶部",
  },
  banner: {
    title: "创意科技",
    subtitle: "专业的服务，专业的解决方案",
    btnText: "联系我们"
  },
  index:{
    whyChooseUs: "为什么选择我们",
    whoAreWe: "专注社交媒体营销",
    whoAreWeen: "我们是做什么的?",
    zixun: "立即咨询我们",
    appWechat: "微信",
    appinstagram: "Instagram",
    apptiktok: "Tiktok",
    appweibo: "微博",
    appxiaohongshu: "小红书",
    appfacebook: "Facebook",
    appdouyin: "抖音",
    apppath: "Path",
    applinkedin: "LinkedIn",
    appyoutube: "油管",
    appx: "推特",
    appshipinhao: "视频号",
    appzhihu: "知乎",
    apptoutiao: "今日头条",
    appkuaishou: "快手",
    appPinterest: "Pinterest",
    qudaoup:"我们的营销渠道",
    qudaomain:"覆盖海内外主流社交媒体平台",
    qudaomainen:"Mainstream Media",
    qudaosmy:"我们深度整合全球高流量社交阵地，精准触达国内外各圈层用户，实现品牌声量全域扩散与高效转化",
  },
  news: {
    detail: "新闻详情",
    publishTime: "发布时间",
    readMore: "阅读更多",
    loading: "加载中...",
    noData: "暂无新闻数据",
    loadError: "加载失败：{msg}",
    weizhi: "您的位置",
    shouye: "首页",
    xinwen: "新闻资讯",
    newsClass: "新闻分类",
    allNews: "全部新闻",
    wushuju: "暂无数据",
    hotNews: "热门新闻",
    shijian: "发布时间",
  },
  contact: {
    leaveMessage: "给我们留言",
    title: "联系我们",
    name: "姓名",
    namePlaceholder: "请输入姓名",
    email: "邮箱",
    emailPlaceholder: "请输入邮箱",
    phone: "手机号",
    phonePlaceholder: "请输入手机号",
    message: "留言",
    messagePlaceholder: "请输入留言",
    submit: "提交",
    submitSuccess: "提交成功",
    submitError: "提交失败",
    loading:'加载中......'
  },
  about: {
    kehu: "我们的客户",
    kehuen: "Our Clients",
  },
  contactus: {
    wechat: '微信咨询',
    phone: '电话咨询',
    wechatQrAlt: '微信二维码',
    wechatTip: '扫码添加客服微信',
    phoneTip: '点击可直接拨打',
    qrError: '二维码加载失败',
    tel:'(+61) 426384498'
  },
  title: {
    home: "首页 - 创意科技",
    newsList: "新闻列表 - 创意科技",
    newsDetail: "新闻详情 - 创意科技"
  },
  nav: {
    home: "首页",
    news: "新闻",
    about: "我们",
    contact: "联系",
    service: "服务",
  }
};